
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/raffle",
      function () {
        return require("private-next-pages/terms/raffle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/raffle"])
      });
    }
  